module.exports = __webpack_public_path__ + "media/packs/images/flags/LC-e640ab2d22c7dc337423542ebc395d77.png";